// extracted by mini-css-extract-plugin
export default {"wrapperStyles":"System_wrapperStyles__WZ05k"};